var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BoxContainer',[(_vm.isLoadingQuotes)?_c('ParagraphLoading'):_c('div',{staticClass:"paragraph"},[_c('Quotes',{staticClass:"paragraph-left"}),(_vm.text)?_c('span',{staticClass:"paragraph-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('FeedbackUser'),_c('Quotes')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }